import { useEffect, useState } from "react";
import { getSettings } from "../getSettings";

function mustGetElementById<T extends HTMLElement>(id: string): T {
  const elementOrNull = document.getElementById(id) as T | null;
  if (elementOrNull === null) throw new Error(id + ' is missing in the document');
  return elementOrNull;
}

const getFromApiElement = (element: HTMLElement) => {
  const dataName = element.getAttribute('data-name');
  const settings = getSettings();
  
  let subType: string;
  switch (dataName) {
    case 'SelfAsserted':
      if (document.querySelector('input[name=extension_mfaByPhoneOrEmail]')) {
        subType = 'mfaSetup';
      } else if (document.getElementById('email_intro')) {
        if (settings.isSignInPolicy) {
          subType = 'migration';
        } else if (settings.isResetMfa) {
          subType = 'resetMfa';
        } else {
          subType = 'signUp';
        }
      } else if (document.getElementById('newPassword')) {
        subType = 'resetPassword';
      } else if (document.getElementById('email')) {
        subType = 'enterEmail';
      } else if (document.getElementById('readOnlyEmail')) {
        subType = 'verifyEmail';
      } else if (document.getElementById('responseMsg')) {
        subType = 'response';
      } else {
        subType = '';
      }
      break;
    case 'Phonefactor':
      if (settings.isResetMfa) {
        if (document.getElementById('countryCode')) {
          subType = 'mfaSetup';
        } else {
          subType = 'continueMfaflow';
        }
      }
      else if (document.getElementById('countryCode')) {
        subType = 'mfaSetup';
      } else {
        subType = 'mfa';
      }
      break;
    default:
      subType = '';
  }
  return [dataName ?? '', subType];
};

export function useProxy() {
  const [name, setName] = useState('');
  const [type, setType] = useState('');

  // JD: do we need an observer here? AFAIK page is reloaded when this change.
  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        const element = mutation.target as HTMLElement;
        const [newName, newType] = getFromApiElement(element);
        setName(newName);
        setType(newType);
      }
    });
    const apiElement = mustGetElementById('api');
    observer.observe(apiElement, { attributes: true, attributeFilter: ['data-name'] });
    const [newName, newType] = getFromApiElement(apiElement);
    setName(newName);
    setType(newType);

    return () => observer.disconnect();
  }, []);

  return { name, type };
}
